import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 40,
	height: 36,
	viewBox: "0 0 40 36",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M36.143 34.643H3.928a3.05 3.05 0 0 1-2.07-.795A2.616 2.616 0 0 1 1 31.928V8.859c0-.72.308-1.41.858-1.92a3.05 3.05 0 0 1 2.07-.795h11.858L19.536 1l3.387 5.143h13.22a3.05 3.05 0 0 1 2.07.795c.55.51.858 1.2.858 1.92v23.07c0 .72-.308 1.411-.857 1.92a3.05 3.05 0 0 1-2.071.795Z",
		stroke: "#000",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2240%22%20height%3D%2236%22%20viewBox%3D%220%200%2040%2036%22%3E%3Cpath%20d%3D%22M36.143%2034.643H3.928a3.05%203.05%200%200%201-2.07-.795A2.616%202.616%200%200%201%201%2031.928V8.859c0-.72.308-1.41.858-1.92a3.05%203.05%200%200%201%202.07-.795h11.858L19.536%201l3.387%205.143h13.22a3.05%203.05%200%200%201%202.07.795c.55.51.858%201.2.858%201.92v23.07c0%20.72-.308%201.411-.857%201.92a3.05%203.05%200%200%201-2.071.795Z%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
